<template>
  <section v-if="amount" class="money-back-card mb-100 p-100 rounded-m">
    <h1 class="title p-200 pb-100 headline-h5-headline bg-neutral-white">
      {{ $t('moneybackcard.title') }}
    </h1>
    <i18n-t class="message p-200 pt-none bg-neutral-white" keypath="moneybackcard.message" tag="p">
      <template #amount>
        <span class="font-medium">{{ amount }}</span>
      </template>
    </i18n-t>
  </section>
</template>

<script lang="ts" setup>
const { redeemMoney } = useRedeemMoney()
const amount = await redeemMoney()
</script>

<style lang="scss" scoped>
.money-back-card {
  background:
    url('./assets/dollars-bg.svg') top right no-repeat,
    token('color/background/accent/success/success');
  background-size: 11.25rem 7.188rem;
  box-shadow: token('shadow/shadow/card/large');

  .title {
    border-top-left-radius: token('size/space/gap/050');
    border-top-right-radius: token('size/space/gap/050');
  }

  .message {
    border-bottom-right-radius: token('size/space/gap/050');
    border-bottom-left-radius: token('size/space/gap/050');
  }
}

@include media-desktop {
  .money-back-card {
    margin-bottom: token('size/space/gap/200');
  }
}
</style>
